var $c1852d2398baa2ff$exports = {};
$c1852d2398baa2ff$exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


export {$c1852d2398baa2ff$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
